import { render, staticRenderFns } from "./ComplaintEditPopup.vue?vue&type=template&id=41f57490&scoped=true&"
import script from "./ComplaintEditPopup.vue?vue&type=script&lang=js&"
export * from "./ComplaintEditPopup.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintEditPopup.vue?vue&type=style&index=0&id=41f57490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f57490",
  null
  
)

export default component.exports